export function formatCurrency(
    value: number = 0,
    noPrefix = false
): string | number {
    if (noPrefix) {
        return value
    }
    const currencyFractionDigits = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).resolvedOptions().maximumFractionDigits
    const valueString = value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        maximumFractionDigits: currencyFractionDigits,
    })
    return valueString
}
